// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_ix-2";
export var aiChatCartContainerExit = "_ix-4";
export var aiChatContainerLarge = "_ix-0";
export var aiChatContainerSmall = "_ix-1";
export var aiChatIcon = "_ix-6";
export var slideInFromRight = "_ix-3";
export var slideOutToRight = "_ix-5";